import { Grid } from '@chakra-ui/react'
import React from 'react'

export const Root = ({ children, ...props }) => {
  return (
    <Grid fontSize="12px" gridTemplateColumns="1fr 100px" columnGap={2} {...props} {...props}>
      {children}
    </Grid>
  )
}
